import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const WhatHiFi: Site = {
  id: 'whathifi',
  logo: 'svg/whathifi.svg',
  label: 'What Hi-Fi?',
  analyticsName: 'whathifi',
  hostname: 'whathifi.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
